<div class="global-loader" fxLayoutAlign="center center">
  <img src="assets/images/loader.gif" class="loader-img" alt="loader" />
  @if (message) {
    <p>{{ message }}</p>
  }
</div>
